'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var RecommendationDetailsCSVExportService = function RecommendationDetailsCSVExportService($filter, momentService, fileSaveService) {
  var UNDERSCORE = '_';
  var HYPHEN = '-';
  var DOW_LABEL_IN_GROUP_BY_ITEM = 'Dow Group';
  var DOW_FIELD_IN_GROUP_BY_ITEM = 'dow';
  var rmMomentFormat = $filter('rmMomentFormat');
  function exportHostViewDateChartsDataToCSV(screenState) {
    var ladderGroupDataList = screenState.recommendationDetailsPanel.ladderGroupChartDataList;
    ladderGroupDataList = getUnexpiredRecommendations(ladderGroupDataList);
    var fileName = getHostViewFileName(ladderGroupDataList, screenState);
    var fileData = createHostViewCsvHeader();
    fileData = _.reduce(ladderGroupDataList, function (result, row) {
      var rawRowArray = createCsvRow(row.data, row.data.market, row.data.hostCarrier);
      _.forEach(rawRowArray, function (rawRow) {
        result += rawRow;
      });
      return result;
    }, fileData);
    fileSaveService.createFile(fileData, 'text/csv;charset=utf-8', fileName + '.csv');
  }
  function exportCompViewDateChartsDataToCSV(screenState) {
    var selectedHostData = screenState.recommendationDetailsPanel.selectedHostLadder.data;
    var fileName = getCompViewFileName(selectedHostData, screenState);
    var fileData = createCompViewCsvHeader();
    fileData += createCsvRow(selectedHostData, selectedHostData.market, selectedHostData.carrier);
    if (selectedHostData.category === 'STRUCTURAL') {
      fileData += !_.isNil(selectedHostData.competitorData1) ? createCsvRow(selectedHostData.competitorData1, selectedHostData.competitorData1.compMarket, selectedHostData.competitorData1.carrier) : '';
      fileData += !_.isNil(selectedHostData.competitorData2) ? createCsvRow(selectedHostData.competitorData2, selectedHostData.competitorData2.compMarket, selectedHostData.competitorData2.carrier) : '';
      fileData += !_.isNil(selectedHostData.competitorData3) ? createCsvRow(selectedHostData.competitorData3, selectedHostData.competitorData3.compMarket, selectedHostData.competitorData3.carrier) : '';
    } else {
      _.each(selectedHostData.competitorsData, function (competitorData) {
        if (!_.isNil(competitorData) && !_.isEmpty(competitorData)) {
          fileData += createCsvRow(competitorData, competitorData.compMarket, competitorData.carrier);
        }
      });
    }
    fileSaveService.createFile(fileData, 'text/csv;charset=utf-8', fileName + '.csv');
  }
  function getHostViewFileName(ladderGroupDataList, screenState) {
    var filePrefix = 'FO_Host_View_Dates_';
    _.forEach(screenState.selectedGroupByItems, function (item) {
      var fieldValue = item === DOW_LABEL_IN_GROUP_BY_ITEM ? ladderGroupDataList[0].data[DOW_FIELD_IN_GROUP_BY_ITEM] : ladderGroupDataList[0].data[_.camelCase(item)];
      filePrefix = filePrefix + fieldValue + UNDERSCORE;
    });
    filePrefix = filePrefix + ladderGroupDataList[0].data.category;
    return filePrefix;
  }
  function getCompViewFileName(contextData, screenState) {
    var filePrefix = 'FO_Comp_View_Dates_';
    _.forEach(screenState.selectedGroupByItems, function (item) {
      var fieldValue = item === 'Dow Group' ? contextData['dow'] : contextData[_.camelCase(item)];
      filePrefix = filePrefix + fieldValue + UNDERSCORE;
    });
    filePrefix = filePrefix + contextData.category;
    return filePrefix;
  }
  function formatAsCsvRow(stringArayToFormat) {
    var rowValues = _.chain(stringArayToFormat).map(function (value) {
      return '"' + value + '"';
    }).join(',').value();
    return rowValues + '\r\n';
  }
  function formatUndefinedData(rowData) {
    return _.isNil(rowData) ? '' : rowData;
  }
  function formatDate(date) {
    if (_.isString(date)) {
      return rmMomentFormat(momentService.of(date, momentService.FIELD.OPT_GROUP_DATE), 'YEAR_MONTH_DAY_NOT_SEPARATED');
    }
    return rmMomentFormat(date, 'YEAR_MONTH_DAY_NOT_SEPARATED');
  }
  function formatUndefinedDateRanges(rowData) {
    if (_.isNil(rowData)) {
      return [];
    }
    return _.chain(rowData).map(function (dateRange) {
      return formatDate(dateRange.begin) + HYPHEN + formatDate(dateRange.end);
    }).join('|').value();
  }
  function getUnexpiredRecommendations(data) {
    return _.filter(data, function (row) {
      return !row.data.isExpired;
    });
  }
  function createCsvRow(rowData, market, carrier) {
    var csvRawRow = [];
    var userOrCurrentDates = getUserOrCurrentDates(rowData);
    csvRawRow.push(formatAsCsvRow([formatUndefinedData(carrier), formatUndefinedData(market), formatUndefinedData(rowData.cabin), formatUndefinedData(rowData.footnote), formatUndefinedData(rowData.routingNumber), formatUndefinedData(rowData.tariffCode), formatUndefinedData(rowData.category), formatUndefinedData(rowData.marketTier), formatUndefinedData(rowData.tripType), formatUndefinedData(rowData.fbc), formatUndefinedData(rowData.fareBrandName), formatUndefinedData(rowData.fareSource), formatUndefinedData(rowData.inboundDow), formatUndefinedData(rowData.dow), formatUndefinedData(formatDate(rowData.effectiveDate)), formatUndefinedData(formatDate(rowData.discontinueDate)), formatUndefinedData(formatDate(userOrCurrentDates.firstTicketDate)), formatUndefinedData(formatDate(userOrCurrentDates.lastTicketDate)), formatUndefinedData(formatDate(userOrCurrentDates.travelFromDate)), formatUndefinedData(formatDate(userOrCurrentDates.travelToDate)), formatUndefinedData(formatDate(userOrCurrentDates.travelCompleteDate)), formatUndefinedDateRanges(userOrCurrentDates.inboundSeasons), formatUndefinedDateRanges(userOrCurrentDates.outboundSeasons), formatUndefinedDateRanges(userOrCurrentDates.inboundBlackouts), formatUndefinedDateRanges(userOrCurrentDates.outboundBlackouts)]));
    return csvRawRow;
  }
  function getUserOrCurrentDates(rowData) {
    if (!isUserAdjustmentsPresent(rowData)) {
      return getCurrentRestrictions(rowData);
    }
    var ticketingDate = consolidateTicketingDates(rowData, 'ticketingDates');
    var travelDate = consolidateTravelDates(rowData, 'outboundTravelDates');
    return {
      firstTicketDate: ticketingDate.firstTicketDate,
      lastTicketDate: ticketingDate.lastTicketDate,
      travelFromDate: travelDate.travelFromDate,
      travelToDate: travelDate.travelToDate,
      travelCompleteDate: travelDate.travelCompleteDate,
      inboundSeasons: rowData.userAdjustedDates.inboundSeasons,
      outboundSeasons: rowData.userAdjustedDates.outboundSeasons,
      inboundBlackouts: rowData.userAdjustedDates.inboundBlackouts,
      outboundBlackouts: rowData.userAdjustedDates.outboundBlackouts
    };
  }
  function consolidateTicketingDates(data, fieldName) {
    var startDate;
    var endDate;
    _.each(data.userAdjustedDates[fieldName], function (element) {
      if (!startDate || isPreviousDate(element.begin, startDate)) {
        startDate = element.begin;
      }
      if (!endDate || isAfterDate(element.end, endDate)) {
        endDate = element.end;
      }
    });
    return {
      firstTicketDate: startDate,
      lastTicketDate: endDate
    };
  }
  function consolidateTravelDates(data, fieldName) {
    var travelFrom;
    var travelTo;
    var travelComplete;
    _.each(data.userAdjustedDates[fieldName], function (element) {
      if (!travelFrom || isPreviousDate(element.from, travelFrom)) {
        travelFrom = element.from;
      }
      if (!travelTo || isAfterDate(element.to, travelTo)) {
        travelTo = element.to;
      }
      if (!travelComplete || isAfterDate(element.complete, travelComplete)) {
        travelComplete = element.complete;
      }
    });
    return {
      travelFromDate: travelFrom,
      travelToDate: travelTo,
      travelCompleteDate: travelComplete
    };
  }
  function isPreviousDate(date1, date2) {
    date1 = getMomentType(date1);
    date2 = getMomentType(date2);
    if (date1 && date2) {
      return date1.isBefore(date2);
    }
    return false;
  }
  function isAfterDate(date1, date2) {
    date1 = getMomentType(date1);
    date2 = getMomentType(date2);
    if (date1 && date2) {
      return date1.isAfter(date2);
    }
    return false;
  }
  function getMomentType(date) {
    return (0, _typeof2["default"])(date) === 'object' ? date : momentService.of(date, momentService.TYPE.LOCAL_DATE);
  }
  function getCurrentRestrictions(rowData) {
    return {
      firstTicketDate: rowData.firstTicketDate,
      lastTicketDate: rowData.lastTicketDate,
      travelFromDate: rowData.travelFromDate,
      travelToDate: rowData.travelToDate,
      travelCompleteDate: rowData.travelCompleteDate,
      inboundSeasons: rowData.inboundSeasons,
      outboundSeasons: rowData.outboundSeasons,
      inboundBlackouts: rowData.inboundBlackouts,
      outboundBlackouts: rowData.outboundBlackouts
    };
  }
  function isUserAdjustmentsPresent(data) {
    if (_.isNil(data.userAdjustedDates)) {
      return false;
    }
    if (!isUserAdjustedDatesNotDefined(data, 'outboundSeasons')) {
      return true;
    }
    if (!isUserAdjustedDatesNotDefined(data, 'outboundBlackouts')) {
      return true;
    }
    if (!isUserAdjustedDatesNotDefined(data, 'inboundSeasons')) {
      return true;
    }
    if (!isUserAdjustedDatesNotDefined(data, 'inboundBlackouts')) {
      return true;
    }
    if (!isUserAdjustedDatesNotDefined(data, 'outboundTravelDates')) {
      return true;
    }
    if (!isUserAdjustedDatesNotDefined(data, 'inboundTravelDates')) {
      return true;
    }
    if (!isUserAdjustedDatesNotDefined(data, 'ticketingDates')) {
      return true;
    }
    if (!isUserAdjustedDatesNotDefined(data, 'reservationDates')) {
      return true;
    }
    return false;
  }
  function isUserAdjustedDatesNotDefined(data, fieldName) {
    return _.isNil(data.userAdjustedDates[fieldName]) || data.userAdjustedDates[fieldName].length === 0;
  }
  function getLabelForKey(key) {
    return KEYS_TO_LABELS[key];
  }
  function createHostViewCsvHeader() {
    var headerLabels = _.map(['hostCarrier', 'market', 'cabin', 'footnote', 'routingNumber', 'tariffCode', 'category', 'marketTier', 'tripType', 'fbc', 'fareBrandName', 'fareSource', 'inboundDaysOfWeek', 'outboundDaysOfWeek', 'effectiveDate', 'discontinueDate', 'firstTicketDate', 'lastTicketDate', 'travelFromDate', 'travelToDate', 'travelCompleteDate', 'inboundSeasons', 'outboundSeasons', 'inboundBlackouts', 'outboundBlackouts'], getLabelForKey);
    return formatAsCsvRow(headerLabels);
  }
  function createCompViewCsvHeader() {
    var headerLabels = _.map(['carrier', 'market', 'cabin', 'footnote', 'routingNumber', 'tariffCode', 'category', 'marketTier', 'tripType', 'fbc', 'fareBrandName', 'fareSource', 'inboundDaysOfWeek', 'outboundDaysOfWeek', 'effectiveDate', 'discontinueDate', 'firstTicketDate', 'lastTicketDate', 'travelFromDate', 'travelToDate', 'travelCompleteDate', 'inboundSeasons', 'outboundSeasons', 'inboundBlackouts', 'outboundBlackouts'], getLabelForKey);
    return formatAsCsvRow(headerLabels);
  }
  var KEYS_TO_LABELS = {
    carrier: 'Carrier',
    hostCarrier: 'Host Carrier',
    market: 'Market',
    cabin: 'Cabin',
    footnote: 'Footnote',
    routingNumber: 'RoutingNumber',
    tariffCode: 'TariffCode',
    category: 'Category',
    entryLevelFbc: 'Market',
    marketTier: 'MarketTier',
    tripType: 'Fare Type Indicator',
    fbc: 'Fbc',
    fareBrandName: 'Fare Brand',
    fareSource: 'Fare Source',
    inboundDaysOfWeek: 'InboundDaysOfWeek',
    outboundDaysOfWeek: 'OutboundDaysOfWeek',
    effectiveDate: 'EffectiveDate',
    discontinueDate: 'DiscontinueDate',
    firstTicketDate: 'FirstTicketDate',
    lastTicketDate: 'LastTicketDate',
    travelFromDate: 'TravelFromDate',
    travelToDate: 'TravelToDate',
    travelCompleteDate: 'TravelCompleteDate',
    inboundSeasons: 'InboundSeasons',
    outboundSeasons: 'OutboundSeasons',
    inboundBlackouts: 'InboundBlackouts',
    outboundBlackouts: 'OutboundBlackouts'
  };
  return {
    exportHostViewDateChartsDataToCSV: exportHostViewDateChartsDataToCSV,
    exportCompViewDateChartsDataToCSV: exportCompViewDateChartsDataToCSV
  };
};
RecommendationDetailsCSVExportService.$inject = ['$filter', 'MomentService', 'FileSaveService'];
module.exports = RecommendationDetailsCSVExportService;